/**
 * Split tests to use in the app
 * Can be passed as a string (name) or an object with configuration
 * See defaults in split-test duck for default variants and other available options
 * @type {String|Array.Object}
 */

module.exports = [
  'BundleRedesign', // Test 414
  'BYOExitOfferModal', // Test 451
  // 'HomePageLimitedTimeDeals', // Test 459
  'BundleRedesignNonGame', // Test 460
  'ShowcaseDarkTheme', // Test 466
  'MysteryBuyAgainTiered', // Test 470
  'ProductSteamReviewsV2', // Test 471
  'SearchPageOpenFiltersPricePlatform', // Test 478
  'TwoKeyMysteryUpsell', // Test 481
  'ProminentPrice', // Test 415
  'FeaturedCarouselTopSellerSlide', // Test 476
];
